module.exports = __webpack_public_path__ + "static/media/universal-studio-japan-1.c0a05885.jpg";